import React from 'react'
import Navbar from '../components/marketing/Navigation'
import Footer from '../components/marketing/Footer'

export default function Terms() {
    return (
        <div className="font-body text-brand-charcoal bg-white min-h-screen flex flex-col">
            <Navbar />

            <main className="flex-grow py-16 lg:py-24">
                <div className="container mx-auto px-6 max-w-3xl">
                    <h1 className="font-heading text-4xl font-bold text-brand-green mb-8">Terms of Service</h1>

                    <p className="text-brand-slate mb-6">
                        <strong>Last updated:</strong> December 2024
                    </p>

                    <div className="prose prose-lg max-w-none text-brand-charcoal">
                        <p className="mb-6">
                            Welcome to Bench Bulletin. By using our service, you agree to these Terms of Service. Please read them carefully.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">1. Acceptance of Terms</h2>
                        <p className="mb-4 text-brand-slate">
                            By accessing or using Bench Bulletin, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, please do not use our service.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">2. Description of Service</h2>
                        <p className="mb-4 text-brand-slate">
                            Bench Bulletin provides a scrimmage finding platform and team management tools for youth hockey managers. We scan publicly available association calendars to identify open ice and scrimmage opportunities.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">3. Account Registration</h2>
                        <ul className="list-disc pl-6 mb-6 space-y-2 text-brand-slate">
                            <li>You must be at least 18 years old to create an account.</li>
                            <li>You are responsible for maintaining the security of your account credentials.</li>
                            <li>You must provide accurate information when registering your team.</li>
                            <li>You may only claim teams that you are authorized to manage.</li>
                        </ul>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">4. Acceptable Use</h2>
                        <p className="mb-4 text-brand-slate">You agree not to:</p>
                        <ul className="list-disc pl-6 mb-6 space-y-2 text-brand-slate">
                            <li>Use the service for any unlawful purpose</li>
                            <li>Post false or misleading scrimmage listings</li>
                            <li>Impersonate another team or manager</li>
                            <li>Attempt to access accounts or data of other users</li>
                            <li>Interfere with the operation of the service</li>
                        </ul>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">5. Payments and Refunds</h2>
                        <p className="mb-4 text-brand-slate">
                            The Pro tier requires a one-time payment per season (6 months). Payments are processed securely through Stripe. We offer a 14-day money-back guarantee—if you're not satisfied, email us for a full refund.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">6. Scrimmage Arrangements</h2>
                        <p className="mb-4 text-brand-slate">
                            Bench Bulletin facilitates connections between team managers. We are not responsible for:
                        </p>
                        <ul className="list-disc pl-6 mb-6 space-y-2 text-brand-slate">
                            <li>The accuracy of information posted by other teams</li>
                            <li>Disputes between teams regarding scrimmages</li>
                            <li>No-shows, cancellations, or scheduling conflicts</li>
                            <li>Ice rental fees or other costs associated with scrimmages</li>
                        </ul>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">7. Disclaimer of Warranties</h2>
                        <p className="mb-4 text-brand-slate">
                            The service is provided "as is" without warranties of any kind. We do not guarantee that calendar scans will be accurate or that all scrimmage opportunities in your area will be found.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">8. Limitation of Liability</h2>
                        <p className="mb-4 text-brand-slate">
                            To the maximum extent permitted by law, Bench Bulletin shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the service.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">9. Termination</h2>
                        <p className="mb-4 text-brand-slate">
                            We reserve the right to suspend or terminate accounts that violate these Terms. You may delete your account at any time through your dashboard settings.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">10. Changes to Terms</h2>
                        <p className="mb-4 text-brand-slate">
                            We may update these Terms from time to time. We will notify you of significant changes via email or through the service. Continued use after changes constitutes acceptance.
                        </p>

                        <h2 className="font-heading text-2xl font-bold text-brand-green mt-10 mb-4">11. Contact</h2>
                        <p className="mb-4 text-brand-slate">
                            Questions about these Terms? Contact us at:
                        </p>
                        <p className="text-brand-slate">
                            <strong>Email:</strong> <a href="mailto:support@benchbulletin.com" className="text-brand-green hover:underline">support@benchbulletin.com</a>
                        </p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    )
}
